import React, { useRef } from "react";
import html2pdf from "html2pdf.js";

const SanctionLetterView = ({ letter, allowDownload }) => {
  const templateRef = useRef();
  
  if (!letter) {
    return <p className="text-center py-4">No data found</p>;
  }

  const handleDownloadPDF = () => {
    if (!templateRef.current) return;

    // Apply PDF-specific styles to fix positioning
    const lonoHeader = templateRef.current.querySelector("h1");
    if (lonoHeader) {
      lonoHeader.style.position = "relative";
      lonoHeader.style.top = "0px";
      lonoHeader.style.marginTop = "0px";
    }

    const opt = {
      margin: 0,
      filename: `${letter.sanctionLetterNo}.pdf`,
      image: { type: "jpeg", quality: 1 },
      html2canvas: { scale: 3, useCORS: true },
      jsPDF: { unit: "mm", format: "a4", orientation: "p" },
    };

    html2pdf()
      .set(opt)
      .from(templateRef.current)
      .save()
      .then(() => {
        // Reset styles after PDF generation
        if (lonoHeader) {
          lonoHeader.style.position = "";
          lonoHeader.style.top = "";
          lonoHeader.style.marginTop = "";
        }
      });
  };

  return (
    <>
      {allowDownload && (
        <div className="flex justify-end mb-2">
          <button
            onClick={handleDownloadPDF}
            className="px-4 py-2 bg-yellow-400 text-black font-semibold rounded"
          >
            Download PDF
          </button>
        </div>
      )}

      <div
        ref={templateRef}
        className="bg-[#33333] mx-auto"
        style={{ width: "794px" }}
      >
        <div className="max-w-3xl mx-auto bg-white shadow-md p-6 rounded-md border border-gray-200 text-black">
          {/* Header with Logo */}
          <div className="relative flex justify-center items-center mb-4">
            <h1 className="text-4xl font-bold text-black">LONO</h1>
            <div className="absolute right-0">
              <img
                src="/assets/lono_logo.jpg"
                alt="LONO Logo"
                className="w-16 h-16 rounded-full object-cover border-2 border-gray-300"
              />
            </div>
          </div>
      <div className="bg-yellow-400 text-center py-2 mb-2 mt-4">
        <p className="text-lg font-semibold">
          EMERGENCY LOANS TO PROTECT FAMILIES
        </p>
      </div>

      {/* Header */}
      <div className="flex justify-between text-sm mb-4">
        <div>
          <p>
            <strong>Date:</strong>{" "}
            {new Date(letter.sanctionDate).toLocaleDateString()}
          </p>
          <p>
            <strong>Sanction Letter No:</strong> {letter.sanctionLetterNo}
          </p>
        </div>
      </div>

      {/* To and Co-Applicant */}
      <div className="flex justify-between mb-6 text-sm">
        <div>
          <p>
            <strong>To.</strong>
          </p>
          <p>{letter.applicantName}</p>
          <p>{letter.address}</p>
          <p>
            {letter.city}, {letter.state}
          </p>
          <p>{letter.pin}</p>
        </div>
        <div>
          <p>
            <strong>Co-Applicant</strong>
          </p>
          <p>
            {letter.coApplicantName || "N/A"} (
            {letter.coApplicantRelation || "-"})
          </p>
        </div>
      </div>

      {/* Subject */}
      <p className="font-semibold mb-4">
        Subject: Sanction of Emergency Loan – ₹{letter.sanctionedAmount}
      </p>

      {/* Body */}
      <p className="mb-4">
        Dear {letter.applicantName}, <br />
        We are pleased to inform you that your Emergency Loan request has been
        sanctioned under the following terms and conditions:
      </p>

      {/* Sanction Details */}
      <h2 className="font-bold mb-2">Sanction Details</h2>
      <ul className="list-disc pl-6 mb-6 text-sm space-y-1">
        <li>
          <strong>Loan Type:</strong> Emergency Loan (Reason: {letter.loanType})
        </li>
        <li>
          <strong>Sanctioned Loan Amount:</strong> ₹{letter.sanctionedAmount}{" "}
          (up to ₹1,00,000)
        </li>
        <li>
          <strong>Rate of Interest (ROI):</strong> {letter.roi}% per annum
        </li>
        <li>
          <strong>Tenure:</strong> {letter.tenure} months
        </li>
        <li>
          <strong>EMI Amount:</strong> ₹{letter.emiAmount}
        </li>
        <li>
          <strong>Processing Fee:</strong> ₹{letter.processingFee} (deducted
          upfront)
        </li>
        <li>
          <strong>Mode of Disbursement:</strong> {letter.modeOfDisbursement || "Direct Credit to Bank Account"}
        </li>
      </ul>

      {/* Co-Applicant Details */}
      <h2 className="font-bold mb-2">Co-Applicant Details</h2>
      <ul className="list-disc pl-6 mb-6 text-sm space-y-1">
        <li>
          <strong>Name:</strong> {letter.coApplicantName || "N/A"}
        </li>
        <li>
          <strong>Relation to Applicant:</strong>{" "}
          {letter.coApplicantRelation || "-"}
        </li>
        <li>
          <strong>Mobile No.:</strong> {letter.coApplicantPhone || "-"}
        </li>
      </ul>

      {/* Footer */}
      <p className="text-sm mb-6">
        We at LONO understand the importance of standing by families in critical
        times. This loan has been designed to support and protect your family
        during emergencies.
      </p>

      <p className="text-sm">
        For any queries, please contact: <strong>768934523</strong>
      </p>

        </div>
      </div>
    </>
  );
};

export default SanctionLetterView;
